import { useEffect, useContext, useState } from 'react';
import ExperienceContext from '../components/ExperienceContext';

let localizedStore;
export const useStore = ({ varnish = true, online = true } = {}) => {
  const { store, clientStore } = useContext(ExperienceContext);
  const cachedStoreId = online ? '8119' : '121';

  let defaultStore = varnish && !localizedStore
    ? { storeId: cachedStoreId }
    : localizedStore || store || { storeId: cachedStoreId };

  if (clientStore) {
    defaultStore = clientStore;
  }


  const [stateStore, setStore] = useState(defaultStore);

  useEffect(() => {
    if (clientStore?.storeId) {
      localizedStore = clientStore;
      setStore(clientStore);
    }
  }, [clientStore?.storeId]);

  return stateStore;
};
